import * as React from 'react';
import { useLanguage } from 'src/providers/LanguageProvider';

const localeMap: Record<string, string> = {
  tr: 'tr-TR',
  en: 'en-US',
  de: 'de-DE',
  nl: 'nl-NL',
};

function safeDate(d?: string | Date | null) {
  if (!d) return null;
  const dt = d instanceof Date ? d : new Date(d);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

const useRelativeTimeFromNow = () => {
  const { language } = useLanguage(); // örn: "tr" | "en" | "de" | "nl"
  const locale = localeMap[language] || language || 'en-US';

  return React.useCallback((iso?: string | Date | null): string => {
    const dt = safeDate(iso);
    if (!dt) return '-';

    const diffMs = dt.getTime() - Date.now(); // negatif => geçmiş, pozitif => gelecek
    const abs = Math.abs(diffMs);

    // numeric: 'auto' => 'yesterday', 'tomorrow' gibi doğal ifadeler
    const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });

    const sec = Math.round(abs / 1000);
    if (sec < 60) return rtf.format(diffMs < 0 ? -sec : sec, 'second');

    const min = Math.round(sec / 60);
    if (min < 60) return rtf.format(diffMs < 0 ? -min : min, 'minute');

    const hr = Math.round(min / 60);
    if (hr < 24) return rtf.format(diffMs < 0 ? -hr : hr, 'hour');

    const day = Math.round(hr / 24);
    if (day < 30) return rtf.format(diffMs < 0 ? -day : day, 'day');

    const mon = Math.round(day / 30);
    if (mon < 12) return rtf.format(diffMs < 0 ? -mon : mon, 'month');

    const yr = Math.round(mon / 12);
    return rtf.format(diffMs < 0 ? -yr : yr, 'year');
  }, [locale]);
};

export default useRelativeTimeFromNow;
